<template>
  <div
    class="trustpilot-widget"
    data-locale="en-GB"
    :data-template-id="templateId"
    :data-businessunit-id="businessUnitId"
    data-style-height="150px"
    data-style-width="100%"
  >
    <a
      href="https://uk.trustpilot.com/review/productfocus.com"
      target="_blank"
      rel="noopener"
      >Trustpilot</a
    >
  </div>
</template>

<script setup lang="ts">
  const {
    public: { TRUSTPILOT_TEMPLATE_ID, TRUSTPILOT_BUSINESSUNIT_ID }
  } = useRuntimeConfig();
  const templateId = ref(TRUSTPILOT_TEMPLATE_ID);
  const businessUnitId = ref(TRUSTPILOT_BUSINESSUNIT_ID);

  onMounted(() =>
    document.head.appendChild(
      Object.assign(document.createElement("script"), {
        src: "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
        async: true,
        onload: () =>
          (window as any).Trustpilot?.loadFromElement(
            document.querySelector(".trustpilot-widget")
          )
      })
    )
  );
</script>
